import { ClassRef } from "@baseline/common/types";
import { useContext } from "./use-context";


export function useService<T>(serviceType: ClassRef<T>): T
{
    const context = useContext();
    return context.require(serviceType);
}
